module.exports = __webpack_public_path__ + "img/pro_fourteen_2.f4efa897.jpg";